import { useSuspenseBillingDetails } from '#api/billing.queries.ts';
import { UpsellFAQ } from '#screens/settings/billing/upsell-faq/UpsellFAQ.tsx';
import { PlanComparison } from './plan-comparison/PlanComparison.tsx';

export function FreePlanDetails() {
  const billingDetails = useSuspenseBillingDetails().data.data;

  // BillingPage already gates on the org's plan; this check exists to narrow the BillingDetails union
  if (billingDetails.plan !== 'free') return null;

  return (
    <>
      <PlanComparison currentHostCount={billingDetails.currentHostCount} />
      <UpsellFAQ />
    </>
  );
}
